import * as type from '../../../actions/index.types'

const initialState = {
    loading: false,
    createLoading: false,
    detailsLoading: false,
    updateLoading: false,
    deleteLoading: false,
    depreciationMethodsLoading: false,
    categoriesLoading: false,
    fixedAssetsData: null,
    fixedAssetDetails: null,
    pagination: null,
    depreciationMethods: null,
    categories: null,
    error: null,
};

export function FixedAssetReducer(state = initialState, action) {
    switch (action.type) {
        // Create Fixed Asset
        case type.CREATE_FIXED_ASSET:
            return { ...state, createLoading: true, error: null }
        case type.CREATE_FIXED_ASSET_SUCCESS:
            return { ...state, createLoading: false, error: null }
        case type.CREATE_FIXED_ASSET_FAILURE:
            return { ...state, createLoading: false, error: action?.message }

        // Get Fixed Assets
        case type.GET_FIXED_ASSETS:
            return { ...state, loading: true, error: null }
        case type.GET_FIXED_ASSETS_SUCCESS:
            return {
                ...state,
                loading: false,
                fixedAssetsData: action.payload?.data || action.payload,
                pagination: action.payload?.pagination || null,
                error: null,
            }
        case type.GET_FIXED_ASSETS_FAILURE:
            return { ...state, loading: false, error: action?.message }

        // Get Depreciation Methods
        case type.GET_DEPRECIATION_METHODS:
            return { ...state, depreciationMethodsLoading: true }
        case type.GET_DEPRECIATION_METHODS_SUCCESS:
            return { ...state, depreciationMethodsLoading: false, depreciationMethods: action.payload }
        case type.GET_DEPRECIATION_METHODS_FAILURE:
            return { ...state, depreciationMethodsLoading: false }

        // Get Fixed Asset Categories
        case type.GET_FIXED_ASSET_CATEGORIES:
            return { ...state, categoriesLoading: true }
        case type.GET_FIXED_ASSET_CATEGORIES_SUCCESS:
            return { ...state, categoriesLoading: false, categories: action.payload }
        case type.GET_FIXED_ASSET_CATEGORIES_FAILURE:
            return { ...state, categoriesLoading: false }

        // Get Fixed Asset Details
        case type.GET_FIXED_ASSET_DETAILS:
            return { ...state, detailsLoading: true, fixedAssetDetails: null, error: null }
        case type.GET_FIXED_ASSET_DETAILS_SUCCESS:
            return { ...state, detailsLoading: false, fixedAssetDetails: action.payload, error: null }
        case type.GET_FIXED_ASSET_DETAILS_FAILURE:
            return { ...state, detailsLoading: false, error: action?.message }

        // Update Fixed Asset
        case type.UPDATE_FIXED_ASSET:
            return { ...state, updateLoading: true, error: null }
        case type.UPDATE_FIXED_ASSET_SUCCESS:
            return { ...state, updateLoading: false, error: null }
        case type.UPDATE_FIXED_ASSET_FAILURE:
            return { ...state, updateLoading: false, error: action?.message }

        // Delete Fixed Asset
        case type.DELETE_FIXED_ASSET:
            return { ...state, deleteLoading: true, error: null }
        case type.DELETE_FIXED_ASSET_SUCCESS:
            return { ...state, deleteLoading: false, error: null }
        case type.DELETE_FIXED_ASSET_FAILURE:
            return { ...state, deleteLoading: false, error: action?.message }

        // Clear State
        case type.CLEAR_FIXED_ASSET_STATE:
            return { ...initialState }

        default:
            return state;
    }
}
